import { css, Theme } from '@emotion/react'
import { alpha, buttonClasses } from '@mui/material'

export const reasonInput = css`
  width: 100%;

  resize: vertical;
`

export const buttonsContainer = css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 24px;
`

export const tableWrapper = (theme: Theme) => css`
  margin-bottom: ${theme.spacing(4)};
  padding: ${theme.spacing(1)};
  border: 1px solid ${theme.colors.backgroundOne};
  border-radius: 16px;
`

export const table = (theme: Theme) => css`
  row-gap: 5px;
  .table-header {
    min-height: 64px;
    padding: ${theme.spacing(0.75, 1.75)};
  }

  .table-row {
    border: none;
    box-shadow: none;
    padding: ${theme.spacing(1.75)};

    &:nth-of-type(2n + 1) {
      background: ${theme.colors.backgroundFive};
    }
  }

  .table-cell {
    font-size: 14px;
    color: ${theme.colors.typographyTwo};
  }
`

export const tableFooter = (theme: Theme) => css`
  display: flex;
  justify-content: flex-end;
  column-gap: ${theme.spacing(1.5)};

  margin-top: ${theme.spacing(2.25)};
  padding: ${theme.spacing(0, 1.5)};
`

export const detailedIpLogButton = (theme: Theme) => css`
  width: 36px;
  height: 36px;

  border-radius: 10px;
  border: 1px solid ${theme.colors.backgroundOne};
  background-color: ${theme.colors.white};
  box-shadow: 0px 2px 2px -1px ${alpha(theme.colors.typographyThree, 0.13)};

  color: ${theme.colors.typographyThree};

  &.${buttonClasses.disabled} {
    cursor: not-allowed;

    svg {
      path {
        opacity: 0.6;
      }
    }
  }
`

export const ipLogDeviceInfoValue = css`
  font-family: monospace;
  font-size: 14px;
`
